import axios from "@/api/axios";
import { useSession } from "./useSession";
import { useState } from "react";

const useGetDetailledDocument = () => {
  const { token } = useSession();
  const [detailError, setDetailError] = useState(null);
  const [detailledData, setDetailledData] = useState(null);

  const getDetailledData = async (id) => {
    if (!id) {
      throw new Error("Document ID is required");
    }

    const url = `/api/v1/workpermits/${id}`;

    try {
      const response = await axios.get(url, {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      setDetailledData(response.data);

      return response.data;
    } catch (err) {
      setDetailError(err);
      throw err; // Propagate error to caller
    }
  };

  return { getDetailledData, detailledData, detailError };
};

export default useGetDetailledDocument;
